import { InputLabel, Stack } from "@mui/material";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";

const DatePickerComponent = (props) => {
  const {
    titleLabel = "",
    value = null,
    setValue = () => {},
    minDate = null,
    maxDate = new Date(),
  } = props;

  return (
    <Stack>
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <DatePicker
          label={titleLabel}
          value={value}
          onChange={(newValue) => setValue(newValue)}
          maxDate={maxDate}
          minDate={minDate}
          slotProps={{
            textField: {
              sx: {
                "& .MuiInputBase-root": {
                  height: "30px",
                  fontSize: "13px",
                  fontFamily: "Raleway, sans-serif",
                },
                "& input": {
                  padding: "4px 8px",
                },
                "& .MuiInputLabel-root": {
                  fontSize: "12px",
                  top: "-6px",
                },
                // 🔽 Quitar el borde negro en hover
                "& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline":
                  {
                    borderColor: "transparent",
                  },
                "& .MuiOutlinedInput-notchedOutline": {
                  borderColor: "#ccc", // opcional: color base del borde
                },
              },
              size: "small",
            },
          }}
        />
      </LocalizationProvider>
    </Stack>
  );
};

export default DatePickerComponent;
